<script lang="ts">
	import type { FuelPrices } from '$lib/components/pois/types';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as c from '$lib/i18n/computedMessages';
	import { getLanguageCode } from '$lib/i18n/language';
	import { formatPastTime } from '$lib/utils/date';
	import * as m from '$paraglide/messages';

	interface Props {
		fuelPrices?: FuelPrices;
		lastUpdated?: Date;
		hiddenLength?: number;
	}

	const { fuelPrices, lastUpdated, hiddenLength }: Props = $props();
</script>

<div data-testid="gas-station-fragment" class="grid gap-y-1 text-body text-coloredneutral-soft p-0 pt-1">
	{#if fuelPrices}
		<ul class="grid gap-y-1 text-body text-sm text-coloredneutral-soft p-0">
			{#each fuelPrices as { type, price } (type)}
				<li class="flex justify-between">
					<span class="truncate">{c.gasStationFuel(type)}</span>
					<span>{price.amount}</span>
				</li>
			{/each}
		</ul>
	{/if}
	{#if hiddenLength !== undefined && hiddenLength > 0}
		<span class="text-coloredneutral-softest text-xs">+ {m.poi_datasheet__availability__view__many__other({ count: hiddenLength })}</span>
	{/if}
	{#if lastUpdated}
		{@const [timeText, _] = formatPastTime(lastUpdated, getLanguageCode())}
		<span class="text-xs text-coloredneutral-softest self-end justify-self-end truncate mt-auto flex items-center">
			<Icon icon="autorenew" />
			{timeText}
		</span>
	{/if}
</div>
